import { z } from 'zod';

export const BlacklistCustomerSchema = z.object({
  tenant_id: z.string().uuid('Invalid tenant id'),
  customer_account_id: z.string().uuid('Invalid customer account id'),
  reason: z
    .string()
    .min(3, 'Reason must be at least 3 characters')
    .max(500, 'Reason too long'),
});

export type BlacklistCustomerInput = z.infer<typeof BlacklistCustomerSchema>;

export const UnblacklistCustomerSchema = z.object({
  tenant_id: z.string().uuid('Invalid tenant id'),
  customer_account_id: z.string().uuid('Invalid customer account id'),
});

export type UnblacklistCustomerInput = z.infer<typeof UnblacklistCustomerSchema>;
